export const CompanyStatusEnumMap = {
  DELETE: -1,
  DISABLE: 0,
  ENABLE: 1,
}

export const useCompanyStatusEnum = () => {
  return {
    enumMap: CompanyStatusEnumMap,
    toString: (status: number) => {
      switch (status) {
        case CompanyStatusEnumMap.DELETE:
          return '已刪除'
        case CompanyStatusEnumMap.DISABLE:
          return '已停用'
        case CompanyStatusEnumMap.ENABLE:
          return '已啟用'
        default:
          return '未知狀態'
      }
    },
  }
}
